// NMN 產品資料
export const products = [
  {
    id: 'nmn-18000',
    sku: 'NMN-001',
    name: 'Youth Secret 輕密酵母 NMN 18000 素食膠囊',
    shortName: '輕密酵母 NMN 18000',
    subtitle: '高劑量NMN補足每日所需份量',
    description: 'NMN（β-菸醯胺單核苷酸）是 NAD⁺ 的前體之一。將 NMN 視為日常營養補充的一環，並配合均衡飲食、規律運動與良好作息，有助維持正常代謝與日常活力。',
    
    // 價格資訊
    pricing: {
      originalPrice: 4900,  // 建議售價
      salePrice: 4900,      // 團購折扣直接套用在建議售價上
      currency: 'TWD',
      unit: '件'
    },
    
    // 團購優惠（按數量折扣）
    bulkDiscounts: {
      1: 0.8,  // 1件 8折
      2: 0.7,  // 2件 7折
      3: 0.6,  // 3件 6折
      6: 0.5,  // 6件以上 5折
    },
    
    // 折扣碼
    discountCodes: [
      {
        code: 'NMN1000',
        type: 'fixed',
        amount: 1000,
        description: '首次體驗折扣 - 折抵 $1,000',
        oneTimeUse: true,
        minQuantity: 1,
      }
    ],
    
    // 產品特色
    features: [
      {
        icon: '🇺🇸',
        title: '美國製造',
        description: 'cGMP品質保證，FDA認證安全可靠'
      },
      {
        icon: '⚡',
        title: '快速吸收',
        description: '10分鐘快速吸收，有效提升NAD⁺'
      },
      {
        icon: '🌱',
        title: '素食膠囊',
        description: '適合素食者，不含動物性成分'
      },
      {
        icon: '🔬',
        title: '高純度配方',
        description: '含葡萄籽萃取物（OPC）與輔酵素Q10'
      }
    ],
    
    // 產品規格
    specifications: {
      netContent: '60 粒 / 瓶',
      servingSize: '每日一次，每次 2 粒',
      usage: '搭配開水食用，多食無益',
      storage: '置於陰涼乾燥處，避免陽光直射',
      shelfLife: '請參考包裝標示',
      origin: '美國',
    },
    
    // 主要成分
    ingredients: [
      '酵母粉（含 β-菸醯胺單核苷酸 NMN）',
      '柑橘生物類黃酮（含橙皮素）',
      '羥丙基甲基纖維素',
      '麥芽糊精',
      '葡萄籽萃取物（含花青素 OPC）',
      '輔酵素 Q10',
      '水',
      '鹿角菜膠',
      '果膠',
      '二氧化鈦',
      '硬脂酸鎂'
    ],
    
    // 注意事項
    warnings: [
      '十五歲以下兒童、懷孕或哺乳期間婦女及服用抗凝血藥者（Warfarin）不宜食用',
      '食用後如有不適，請停止食用並諮詢醫師',
      '若封膜破損，請勿食用',
      '請放在嬰幼兒不易取得之處',
    ],
    
    // 不含成分（過敏原資訊）
    allergenFree: [
      '牛奶',
      '蛋',
      '魚',
      '貝類',
      '堅果',
      '小麥',
      '大豆',
      '人工色素',
      '人工香料',
      '乳糖',
      '麩質',
      '防腐劑',
      '基因改造成分'
    ],
    
    // 產品圖片
    images: [
      {
        url: '/product-images/nmn-main.jpg',
        alt: 'Youth Secret 輕密酵母 NMN 18000 主圖',
        isPrimary: true
      },
      {
        url: '/product-images/nmn-ingredients.jpg',
        alt: 'NMN 成分說明',
        isPrimary: false
      },
      {
        url: '/product-images/nmn-usage.jpg',
        alt: 'NMN 食用方式',
        isPrimary: false
      },
      {
        url: '/product-images/nmn-certificate.jpg',
        alt: 'NMN 認證標章',
        isPrimary: false
      }
    ],
    
    // FAQ
    faqs: [
      {
        question: 'NMN 是什麼？',
        answer: 'NMN（β-菸醯胺單核苷酸）是 NAD⁺ 的前體之一。NAD⁺ 為多項能量代謝相關反應的重要輔酶。NMN 常被作為日常營養補充的一環，搭配均衡飲食與規律作息，有助維持正常代謝與活力。'
      },
      {
        question: 'Youth Secret 輕密酵母 18000 的主要特色是什麼？',
        answer: '採用含 NMN 的酵母配方，並搭配葡萄籽萃取物（OPC）與 Q10；素食膠囊，通過安全檢測，不含人工色素與防腐劑。'
      },
      {
        question: '建議如何食用？',
        answer: '每日一次，每次 2 粒，配開水食用。可依個人作息安排固定時段，建議搭配均衡飲食與規律運動。'
      },
      {
        question: '是否含咖啡因或動物性成分？',
        answer: '配方未添加咖啡因，採素食膠囊設計；不含牛奶、蛋、魚、貝類、堅果、小麥與大豆等常見過敏原來源成分，詳見成分標示。'
      },
      {
        question: '可以與其他營養品一起食用嗎？',
        answer: '一般情況可與常見營養品（如維生素、礦物質）搭配食用。若您正在使用藥物（特別是抗凝血藥品）或有特殊飲食需求，建議先諮詢專業醫事人員。'
      },
      {
        question: '哪些族群不建議食用？',
        answer: '十五歲以下、孕期或哺乳期、以及服用抗凝血藥者不宜食用。若食用後感到不適，請停止食用並諮詢醫師。'
      },
      {
        question: '這是一種藥品嗎？',
        answer: '本產品屬一般食品，作為日常營養補充的一環，非藥品，非用於預防、診斷、治療或矯正任何疾病。'
      }
    ],
    
    // 退換貨政策
    returnPolicy: {
      period: 7,
      conditions: [
        '退貨商品須保持全新、未拆封且包裝完整',
        '請於收貨後 7 天內提出申請，逾期恕不受理',
        '組合商品退貨須一併退回贈品與發票',
        '每張訂單提供一次免費退貨服務'
      ],
      processingTime: '約 14 個工作天（不含假日）'
    },
    
    // 運送資訊
    shipping: {
      freeShipping: true,
      freeShippingThreshold: 0,
      estimatedDays: '1-3 個工作天',
      availableRegions: ['台灣本島', '離島地區'],
      note: '此商品可配送離島區域'
    },
    
    // 供應商資訊
    supplier: {
      name: '沛能股份有限公司',
      address: '台北市大同區承德路三段 230 號 2 樓',
      phone: '02-77307865',
      registrationNumber: 'A-183409284-00000-6',
      insurance: '產品責任險 2000 萬元'
    },
    
    // 庫存狀態
    stock: {
      available: true,
      quantity: 999,
      lowStockThreshold: 10,
      maxPurchaseQuantity: 99,
      minPurchaseQuantity: 1
    },
    
    // SEO 資訊
    seo: {
      title: 'Youth Secret 輕密酵母 NMN 18000 素食膠囊 - 高純度NAD+前體補充',
      description: '美國製造cGMP品質保證，10分鐘快速吸收，有效提升NAD⁺。含葡萄籽萃取物（OPC）與輔酵素Q10，素食膠囊設計。',
      keywords: ['NMN', 'NAD+', '輕密酵母', 'Youth Secret', '素食膠囊', '抗衰老', '營養補充']
    },
    
    // 產品標籤
    tags: ['熱銷商品', '美國製造', '素食', 'FDA認證', '團購優惠'],
    
    // 類別
    category: '營養補充品',
    subcategory: 'NMN/NAD+',
    
    // 產品狀態
    status: 'active',
    featured: true,
    newArrival: false,
    
    // 建立與更新時間
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2026-01-29T00:00:00Z',
  }
];

// 輔助函數：根據 ID 取得產品
export const getProductById = (id) => {
  return products.find(product => product.id === id);
};

// 輔助函數：根據 SKU 取得產品
export const getProductBySku = (sku) => {
  return products.find(product => product.sku === sku);
};

// 輔助函數：取得所有活躍產品
export const getActiveProducts = () => {
  return products.filter(product => product.status === 'active');
};

// 輔助函數：取得精選產品
export const getFeaturedProducts = () => {
  return products.filter(product => product.featured);
};

// 輔助函數：計算團購折扣後價格
export const calculateBulkPrice = (product, quantity) => {
  const basePrice = product.pricing.salePrice;
  const discounts = product.bulkDiscounts;
  
  // 找出適用的折扣（取最大的適用數量）
  let applicableDiscount = 1; // 預設無折扣
  const sortedKeys = Object.keys(discounts).map(Number).sort((a, b) => b - a);
  
  for (const threshold of sortedKeys) {
    if (quantity >= threshold) {
      applicableDiscount = discounts[threshold];
      break;
    }
  }
  
  return Math.round(basePrice * applicableDiscount * quantity);
};

// 輔助函數：取得團購折扣資訊
export const getBulkDiscountInfo = (product, quantity) => {
  const discounts = product.bulkDiscounts;
  const sortedKeys = Object.keys(discounts).map(Number).sort((a, b) => b - a);
  
  for (const threshold of sortedKeys) {
    if (quantity >= threshold) {
      const discountRate = (1 - discounts[threshold]) * 100;
      return {
        applicable: true,
        threshold,
        rate: discounts[threshold],
        discountPercentage: discountRate,
        message: `${threshold} 件享 ${Math.round(discounts[threshold] * 10)} 折優惠`
      };
    }
  }
  
  return {
    applicable: false,
    threshold: 0,
    rate: 1,
    discountPercentage: 0,
    message: ''
  };
};

// 預設匯出主要產品（第一個產品）
export default products[0];
